import { render, staticRenderFns } from "./classes.vue?vue&type=template&id=cda840f4"
import script from "./classes.vue?vue&type=script&lang=js"
export * from "./classes.vue?vue&type=script&lang=js"
import style0 from "./classes.vue?vue&type=style&index=0&id=cda840f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports